import type { Channel, DogEntryPage } from "@/api_client";
import { DogEntryForm } from "@/components/products/dog/entry/DogEntryForm";
import { ProductContainer } from "@/components/shared/productContainer/ProductContainer";
import { useEntryForWebComponents } from "../hooks/useEntryForWebComponents";

type DogEntryProps = {
  backendHost?: string;
  appPathPrefix?: string;
  skipCart: boolean;
  channel?: Channel;
  language?: string;
};

export default function DogEntry({
  backendHost,
  appPathPrefix,
  skipCart,
  channel,
  language,
}: Readonly<DogEntryProps>) {
  const {
    isLoading,
    isSubmitting,
    submitEntryHandler,
    policyHolder,
    user,
    content,
  } = useEntryForWebComponents<DogEntryPage>({
    productType: "dog",
    backendHost,
    appPathPrefix,
    skipCart,
    channel,
    contentPageKey: "dogEntryPage",
    language,
  });

  if (isLoading) return <ProductContainer.Loader />;

  return (
    <DogEntryForm
      externalIsLoading={isSubmitting}
      externalSubmitHandler={submitEntryHandler}
      externalPolicyHolder={policyHolder}
      externalUser={user}
      externalContent={content}
    />
  );
}
